import * as THREE from 'three';
import AssetManager from '../managers/AssetManager';

// Map public skin names to AssetManager texture keys
export const SKIN_TO_TEXTURE: Record<string, string> = {
  T90A: 'textureA',
  T90B: 'textureB',
  T90C: 'textureC',
  T90D: 'textureD',
  T90E: 'textureE',
  T90F: 'textureF',
  T90G: 'textureG',
};

export function getTextureForSkin(skinName: string): THREE.Texture | null {
  const textureKey = SKIN_TO_TEXTURE[skinName] || skinName;
  try {
    const tex = AssetManager.getTexture(textureKey) as THREE.Texture;
    return tex ?? null;
  } catch (_e) {
    // Texture not yet loaded or invalid key
    return null;
  }
}

export function applySkinToObject(root: THREE.Object3D, texture: THREE.Texture): void {
  root.traverse((child: THREE.Object3D) => {
    const anyChild = child as any;
    if (anyChild.isMesh) {
      const mesh = anyChild as THREE.Mesh & {
        material: THREE.Material & { map?: THREE.Texture; needsUpdate?: boolean };
      };
      (mesh.material as any).map = texture;
      (mesh.material as any).needsUpdate = true;
    }
  });
}

